import './styles.scss';

export default {
    name: 'FixtureDetailPage',

    data() {
        return {
            editing: false,
            fixture: {}
        }
    },
    
    computed: {
        stored_fixture() {
            return this.$store.getters.getFixture(this.$route.params.id);
        },

        types() {
            return this.$store.getters.getFixtureTypes;
        },

        readonly() {
            let readonly = !this.editing;
            return readonly.toString();
        },

        list() {
            return this.$store.state.fixtures.fixtures_list;
        },

        subscription() {
            return this.$store.getters.getActiveSubscription;
        },
        
        canEdit() { 
            return this.subscription.permissions.includes('ugc_create');
        }
    },

    watch: {
        stored_fixture: 'onRoute',

        list() {
            this.$store.commit('setMenuItems', this.$store.getters.getFixturesList);
        }
    },

    created() {
        this.onRoute();

        this.$store.commit('setMenuItems', this.$store.getters.getFixturesList);
        this.$store.commit('setMenuDetails', { title: 'Fixtures', slug: 'fixtures', back_url: '/action/operations' });
    },

    methods: {
        onRoute() {
            if (this.stored_fixture) {
                this.fixture = this.stored_fixture;
            }
        },

        save() {
            if (this.$store.state.online_status) {
                if (this.$store.state.online_status) {
                    if (this.editing) {
                        this.submitUpdate();
                    } else {
                        this.editing = true;
                    }
                }
            } else {
                this.$ionic.alertController.create({
                    message: 'Please establish and internet connection and try again.',
                    buttons:['OK']
                }).then(a => a.present());
            }
        },

        submitUpdate() {
            const ctx = {
                id: this.fixture.id,
                content: {
                    location: this.fixture.location,
                    description: this.fixture.description, 
                    type: this.fixture.type
                }
            };

            this.$store.dispatch('updateFixtureDB', ctx).then((response) => {
                this.editing = false;
            }).catch((error) => {
                this.$ionic.alertController.create({
                    message: 'Unable to save changes.',
                    buttons:['OK']
                }).then(a => a.present());
            });
        },

        deleteFixture() {
            if (this.$store.state.online_status) {
                this.$ionic.alertController.create({
                    header: "Are you sure?",
                    message: "This action cannot be undone.",
                    buttons: [
                        {
                            text: 'Cancel',
                            role: 'cancel'
                        },
                        {
                            text: 'Delete Fixture',
                            handler: () => {
                                if (this.$store.state.online_status) {
                                    this.$store.dispatch('deleteFixtureDB', this.fixture.id).then((response) => {
                                        this.$router.push('/action/operations/fixtures#back');
                                    }).catch((error) => {
                                        this.$ionic.alertController.create({
                                            message: 'Unable to delete fixture.',
                                            buttons:['OK']
                                        }).then(a => a.present());
                                    });
                                } else {
                                    this.$ionic.alertController.create({
                                        message: 'Please establish and internet connection and try again.',
                                        buttons:['OK']
                                    }).then(a => a.present());
                                }
                            },
                        },
                    ],
                }).then(a => a.present());
            } else {
                this.$ionic.alertController.create({
                    message: 'Please establish and internet connection and try again.',
                    buttons:['OK']
                }).then(a => a.present());
            }
        }
    }
};